import {
  addHtmlElementClass,
  addHtmlElementEventListener,
  appendHtmlElementChild,
  CURRENCY_EURO,
  customToString,
  enableHtmlElement,
  getHtmlElement,
  isDefined,
  isPresent,
  parseAmount,
  removeHtmlElementClass,
  renderWebComponent,
  sanitize,
  scrollHtmlElementIntoView,
  setHtmlElementContent,
  setHtmlElementValue,
  string2obj,
  veryVeryHighDebouncedFunction,
  checkDeferredPayment,
  EASE_IN_TRANSITION_TIME,
  hasValidVoucher,
  INSURANCE_TOU_ACCEPTED_KEY_FOR_SESSION_STORAGE,
  INSURANCE_GUIDELINES_ACCEPTED_KEY_FOR_SESSION_STORAGE,
  insuranceRequested,
  removeHtmlChildren,
  checkHtmlElement
} from "../../../utils/utils";
import I18n from 'i18n.js.erb';
import commonStyles from '../../styles/web-components.common.css';
import submissionListsStyles from '../../styles/submission-lists.css';
import { EventBusComponent } from "../EventBusComponent";
import { SubmissionListPaymentComponent } from "./SubmissionListPaymentComponent";
import {SubmissionListDeferredPaymentModalComponent} from "./SubmissionListDeferredPaymentModalComponent";


export class SubmissionListSummaryComponent extends HTMLElement {

  props = {};
  showMiddlemanPrices = true;
  discountCode = ''
  acceptedTou = false;

  static get observedAttributes() {
    return [ 'props' ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue)
      this.props = string2obj(newValue);
    if (isPresent(this.props.submissionList.voucher?.code))
      this.discountCode = this.props.submissionList.voucher.code;
    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
    this.eventBus = EventBusComponent.getInstance();
  }

  connectedCallback() {
    this.eventBus.subscribe('updated-submission-list-state', (submissionList) => this.updateSubmissionListState(submissionList) );
    addHtmlElementEventListener(this.shadowRoot, 'apply_voucher_btn', 'click', (e) => this.handleApplyVoucher())
    addHtmlElementEventListener(this.shadowRoot, 'discountCode', 'input', (e) => this.setDiscountCode(e.target.value.toString().replaceAll(' ', '')))

    this.eventBus.subscribe('changed-middleman-price-rendering', (show) => {
      this.showMiddlemanPrices = show;
      this.handleFormConfirmationSectionRendering();
    });

    // Se l'utente decide di annullare il checkout finale della submission list,
    // repristino il bottone di conferma della submission list
    this.eventBus.subscribe('cancelled-submission-list-checkout', (submissionList) => {
      enableHtmlElement(this.shadowRoot, 'confirm_and_pay_btn', true);
    });
  }


  // Funzione che aggiorna lo stato corrente della submission list quando gli altri componenti segnalano tale evento sull'eventBus
  updateSubmissionListState(submissionList) {
    if (this.props.submissionList.grader_company_id !== submissionList.grader_company_id) {
      setHtmlElementValue(this.shadowRoot, "discountCode", "");
      this.setDiscountCode('');
      setHtmlElementContent(this.shadowRoot, 'invalidCouponMsg', submissionList.voucher.invalid_voucher_message);
    }

    this.props.submissionList = { ...submissionList};

    this.renderRemarks();

    this.handlePricesSummaryRendering();

    // Il riquadro del codice promo si mostra su ogni ordine, anche su quelli inseriti da un point: i
    // codici non sono piu' appannaggio dei soli clienti diretti, e a decidere chi puo' spenderli e'
    // il campo usable_by del singolo codice
    removeHtmlElementClass(this.shadowRoot, 'coupon-row', 'd-none');

    if (isPresent(this.props.submissionList.grader_company.home_pick_up_method) || isPresent(this.props.submissionList.grader_company.return_delivery_method)) {
      removeHtmlElementClass(this.shadowRoot, "shipping_cost_container", "d-none");
      removeHtmlElementClass(this.shadowRoot, "customer_shipping_cost_container", "d-none");
    }
    else {
      addHtmlElementClass(this.shadowRoot, 'shipping_cost_container', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'customer_shipping_cost_container', 'd-none');
    }

    if (this.props.submissionList.grader_company.has_insurance_options) {
      removeHtmlElementClass(this.shadowRoot, "insurance_cost_container", "d-none");
      removeHtmlElementClass(this.shadowRoot, "customer_insurance_cost_container", "d-none");
    }
    else {
      addHtmlElementClass(this.shadowRoot, 'insurance_cost_container', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'customer_insurance_cost_container', 'd-none');
    }

    if (this.enableSubmissionListConfirmation()) {
      this.handleRenderingSubmissionListValidatorSubbanner('validations_container', false, () => {
        this.clearValidationMessages();
      });
    } else {
      this.clearValidationMessages();
    }
  }


  // Funzione che esegue il parsing dell'aliquota IVA applicata alla submission list e che va renderizzata a video
  parseVatRate = () => {
    if (!this.props.submissionList.is_middleman_for_company || this.props.submissionList.vat_rate !== 0.0)
      return `${this.props.submissionList.vat_rate}%`;
    else return I18n.t('js.editSubmissionListPage.webComponent.draft.vatRateNotApplicable').toUpperCase();
  }


  // Funzione che gestisce il rendering sull'interfaccia grafica delle eventuali raccomandazioni che la casa di
  // gradazione rivolge al cliente finale prima che confermi l'ordine
  renderRemarks() {
    const remarksContainer = getHtmlElement(this.shadowRoot, 'remarks_container');
    removeHtmlChildren(remarksContainer);

    const serviceType = this.props.submissionList.service_type;
    const companyRemarks = this.props.submissionList.grader_company.remarks || [];

    if (!serviceType && companyRemarks.length === 0) return;

    // Claim del tipo ordine selezionato: stesso titolo e stessi 3 claim mostrati nelle tessere
    const selectedOrderClaims = serviceType
      ? `<div class="col-12 col-md-6 col-xl-4 pb-3">
          <h6><b class="mr-1">${I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${serviceType}.title`)}</b></h6>
          ${[1, 2, 3].map((n) =>
            `<div class="d-flex mb-0">
              <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1">
              <div class="pl-2">
                ${I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${serviceType}.bullet${n}`)}
              </div>
            </div>`
          ).join('')}
        </div>`
      : '';

    const companyRemarksMarkup = companyRemarks.map((remark) =>
      `<div class="col-12 col-md-6 col-xl-4 pb-3">
        <h6><b class="mr-1">${remark.title}</b></h6>
        ${
          remark.body.map((checkmark) =>
            `<div class="d-flex mb-0">
              <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1">
              <div class="pl-2">
                ${checkmark}
              </div>
            </div>`
          ).join('')
        }
      </div>`
    ).join('');

    const template = document.createElement('template')
    template.innerHTML = `
      <div class="mt-5 align-items-center">
        <div class="row d-flex justify-content-center text-center text-aig-gradient">
          <h2><b>${I18n.t('js.editSubmissionListPage.webComponent.draft.remarksSectionTitle')}</b></h2>
        </div>
      </div>

      <div class="row border-solid br-20px shadow pt-0 z-index-125 m-auto d-flex justify-content-center flex-wrap px-1 pt-3 pb-0">
        ${selectedOrderClaims}
        ${companyRemarksMarkup}
      </div>
    `

    appendHtmlElementChild(remarksContainer, template.content.cloneNode(true));
  }


  // Funzione che gestisce il rendering sull'interfaccia grafica del riepilogo finale dei prezzi della submission list
  handlePricesSummaryRendering() {
    if (!this.props.submissionList.is_middleman_for_company) {
      removeHtmlElementClass(this.shadowRoot, 'customer_summary', 'd-block');
      addHtmlElementClass(this.shadowRoot, 'customer_summary', 'd-none');
      removeHtmlElementClass(this.shadowRoot, 'summary', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'summary', 'd-block');
      removeHtmlElementClass(this.shadowRoot, 'middleman_prices_title', 'd-flex');
      addHtmlElementClass(this.shadowRoot, 'middleman_prices_title', 'd-none');

      // Calcola il prezzo dei servizi PRIMA dello sconto special pricing
      const serviceAmountBeforeDiscount = this.props.submissionList.customer_base_service_amount;

      setHtmlElementContent(this.shadowRoot, 'summary_box_title_1', I18n.t('js.editSubmissionListPage.webComponent.draft.payment.service_amount').toUpperCase());
      setHtmlElementContent(this.shadowRoot, 'summary_box_content_1', parseAmount(serviceAmountBeforeDiscount, 2, true));

      setHtmlElementContent(this.shadowRoot, 'summary_box_title_2', I18n.t('js.editSubmissionListPage.webComponent.draft.payment.discount').toUpperCase());

      // Mostra lo sconto separando voucher e special pricing
      let discountValue = '--';

      if (hasValidVoucher(this.props.submissionList)) {
        let voucherText = '';

        if (hasValidVoucher(this.props.submissionList)) {
          voucherText = this.props.submissionList.voucher.amount > 0 ?
            parseAmount(this.props.submissionList.voucher.amount, 2) + CURRENCY_EURO
            :
            (this.props.submissionList.voucher.percentage || 0) + '%';
        }
        
        discountValue = '-' + voucherText;
      }

      setHtmlElementContent(this.shadowRoot, 'summary_box_content_2', discountValue);

      setHtmlElementContent(this.shadowRoot, 'summary_box_title_3', I18n.t('js.editSubmissionListPage.webComponent.draft.payment.shipping').toUpperCase());
      setHtmlElementContent(this.shadowRoot, 'summary_box_content_3', parseAmount(this.props.submissionList.global_shipping_cost, 2, true) + CURRENCY_EURO);

      setHtmlElementContent(this.shadowRoot, 'summary_box_title_4', I18n.t('js.editSubmissionListPage.webComponent.draft.payment.insurance').toUpperCase());
      setHtmlElementContent(this.shadowRoot, 'summary_box_content_4', isDefined(this.props.submissionList.insurance_cost) && this.props.submissionList.insurance_cost > 0 ? parseAmount(this.props.submissionList.insurance_cost, 2, true) + CURRENCY_EURO : I18n.t('js.editSubmissionListPage.webComponent.draft.payment.notApplied').toUpperCase());

      setHtmlElementContent(this.shadowRoot, 'summary_box_title_5', I18n.t('js.editSubmissionListPage.webComponent.draft.payment.usedCredit').toUpperCase());
      setHtmlElementContent(this.shadowRoot, 'summary_box_content_5', parseAmount(this.props.submissionList.user_credit, 2, true) + CURRENCY_EURO);

      setHtmlElementContent(this.shadowRoot, 'summary_box_title_6', I18n.t('js.editSubmissionListPage.webComponent.draft.payment.paidAmount').toUpperCase());
      setHtmlElementContent(this.shadowRoot, 'summary_box_content_6', parseAmount(this.props.submissionList.amount, 2, true) + CURRENCY_EURO);
      setHtmlElementContent(this.shadowRoot, 'summary_box_content_6_vat', `${this.props.submissionList.vat_rate}`);
    } else {
      removeHtmlElementClass(this.shadowRoot, 'customer_summary', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'customer_summary', 'd-block');
      removeHtmlElementClass(this.shadowRoot, 'middleman_prices_title', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'middleman_prices_title', 'd-flex');

      setHtmlElementContent(this.shadowRoot, 'summary_box_title_1', `${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.service_amount')} ${I18n.t('js.editSubmissionListPage.webComponent.draft.vatExcluded')}`.toUpperCase());
      setHtmlElementContent(this.shadowRoot, 'summary_box_content_1', parseAmount(this.props.submissionList.base_service_amount_vat_excluded, 2, true));
      setHtmlElementContent(this.shadowRoot, 'customer_summary_box_content_1', parseAmount(this.props.submissionList.customer_base_service_amount, 2, true));

      setHtmlElementContent(this.shadowRoot, 'summary_box_title_2', `${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.shipping')} ${I18n.t('js.editSubmissionListPage.webComponent.draft.vatExcluded')}`.toUpperCase());
      setHtmlElementContent(this.shadowRoot, 'summary_box_content_2', parseAmount(this.props.submissionList.global_shipping_cost_vat_excluded, 2, true) + CURRENCY_EURO);
      setHtmlElementContent(this.shadowRoot, 'customer_summary_box_content_2', parseAmount(this.props.submissionList.global_shipping_cost, 2, true) + CURRENCY_EURO);

      setHtmlElementContent(this.shadowRoot, 'summary_box_title_3', `${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.insurance')} ${I18n.t('js.editSubmissionListPage.webComponent.draft.vatExcluded')}`.toUpperCase());
      setHtmlElementContent(this.shadowRoot, 'summary_box_content_3', parseAmount(this.props.submissionList.insurance_cost_vat_excluded, 2, true) + CURRENCY_EURO);
      setHtmlElementContent(this.shadowRoot, 'customer_summary_box_content_3', parseAmount(this.props.submissionList.insurance_cost, 2, true) + CURRENCY_EURO);

      setHtmlElementContent(this.shadowRoot, 'summary_box_title_4', I18n.t('js.editSubmissionListPage.webComponent.draft.vatRate').toUpperCase());
      setHtmlElementContent(this.shadowRoot, 'summary_box_content_4', `${this.parseVatRate()}`);
      setHtmlElementContent(this.shadowRoot, 'customer_summary_box_content_4', `${this.props.submissionList.customer_vat_rate}%`);

      setHtmlElementContent(this.shadowRoot, 'summary_box_title_5', I18n.t('js.editSubmissionListPage.webComponent.draft.vatAmount').toUpperCase());
      setHtmlElementContent(this.shadowRoot, 'summary_box_content_5', parseAmount(this.props.submissionList.vat_amount, 2, true) + CURRENCY_EURO);
      setHtmlElementContent(this.shadowRoot, 'customer_summary_box_content_5', parseAmount(this.props.submissionList.customer_vat_amount, 2, true) + CURRENCY_EURO);

      setHtmlElementContent(this.shadowRoot, 'summary_box_title_6', I18n.t('js.editSubmissionListPage.webComponent.draft.payment.middlemanAmount').toUpperCase());
      setHtmlElementContent(this.shadowRoot, 'summary_box_content_6', parseAmount(this.props.submissionList.amount, 2, true) + CURRENCY_EURO);
      setHtmlElementContent(this.shadowRoot, 'customer_summary_box_content_6', parseAmount(this.props.submissionList.customer_amount, 2, true) + CURRENCY_EURO);
      setHtmlElementContent(this.shadowRoot, 'summary_box_content_6_vat', `${this.props.submissionList.vat_rate}`);
    }
  }


  // Funzione che gestisce il rendering sull'interfaccia grafica della sezione che permette all'utente di
  // confermare la submission list
  handleFormConfirmationSectionRendering () {
    let rowIdToAddConfirmationSection = '';
    if (this.showMiddlemanPrices) {
      removeHtmlElementClass(this.shadowRoot, 'summary', 'd-none');
      removeHtmlChildren(getHtmlElement(this.shadowRoot, 'customer_confirmation_section_container'));
      rowIdToAddConfirmationSection = 'confirmation_section_container';
    }
    else {
      addHtmlElementClass(this.shadowRoot, 'summary', 'd-none');
      removeHtmlChildren(getHtmlElement(this.shadowRoot, 'confirmation_section_container'));
      rowIdToAddConfirmationSection = 'customer_confirmation_section_container';
    }

    const row = document.createElement('template');
    row.innerHTML = `      
      <div class="d-flex justify-content-end justify-content-lg-start align-items-center py-1">
        <input
          type="checkbox"
          class="cursor-pointer touCheckbox${rowIdToAddConfirmationSection.indexOf('customer') === -1 ? '-white' : ''}"
          id="touCheckbox"
        />
        &nbsp;
        <label class="ml-1 mb-0 cursor-pointer" for="touCheckbox">
          ${I18n.t('js.editSubmissionListPage.subscribe')}
          <a href="${'/' + this.props.locale + '/grading_service_terms_of_use.html'}"
             target="_blank"
             class="color-${rowIdToAddConfirmationSection.indexOf('customer') === -1 ? 'white' : 'black'} text-underline-imp">
            ${I18n.t('js.editSubmissionListPage.userAggregatorContractSubscription')}
          </a>
        </label>
      </div>
      
      <div class="text-right align-items-center py-1">
        <button
          id="confirm_and_pay_btn"
          class="btn-standard ${rowIdToAddConfirmationSection.indexOf('customer') === -1 ? 'bg-white-imp' : 'bg-aig-gradient'} br-50px border-none-imp px-5"
          type="button"
        >
          <span class="${rowIdToAddConfirmationSection.indexOf('customer') === -1 ? 'text-aig-gradient' : 'text-white'}">
            ${I18n.t(`js.editSubmissionListPage.webComponent.draft.confirmAnd${checkDeferredPayment(this.props.submissionList.payment_terms) || !this.props.submissionList.enable_payment ? 'Continue' : 'Pay'}`).toUpperCase()}
          </span>
        </button>
      </div>
    `

    appendHtmlElementChild(getHtmlElement(this.shadowRoot, rowIdToAddConfirmationSection), row.content.cloneNode(true));

    checkHtmlElement(this.shadowRoot, 'touCheckbox', this.acceptedTou);
    addHtmlElementEventListener(this.shadowRoot, 'touCheckbox', 'change', (e) => this.setTouCheckbox());
    addHtmlElementEventListener(this.shadowRoot, 'confirm_and_pay_btn', 'click', () => this.proceedToCheckout());

    addHtmlElementEventListener(this.shadowRoot, 'customer_pricing_details_link', 'click', (e) => this.eventBus.publish('render-submission-list_pricing-summary-modal', { ...this.props.submissionList, priceType: 'customer_' }))
    addHtmlElementEventListener(this.shadowRoot, 'pricing_details_link', 'click', (e) => this.eventBus.publish('render-submission-list_pricing-summary-modal', { ...this.props.submissionList, priceType: '' }))
  }


  // Funzione che verifica se si possano nascondere dall'interfaccia grafica i messaggi che informano all'utente che
  // qualche dato manca (o è invalido) prima che possa procedere al checkout
  clearValidationMessages() {
    if (this.itemsPresent())
      addHtmlElementClass(this.shadowRoot, 'invalid-items-message', 'd-none');
    if (!this.unavailableProService())
      addHtmlElementClass(this.shadowRoot, 'unavailable-pro-service-message', 'd-none');
    if (this.homePickupAddressPresent())
      addHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-address-message', 'd-none');
    if (this.homePickUpFavoriteDayPresent()) {
      if (!getHtmlElement(this.shadowRoot, 'invalid-home-pick-up-day-message').classList.contains('d-none') && !this.validHomePickUpFavoriteDay())
        removeHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-day-message-2', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-day-message', 'd-none');
    }
    if (this.homePickUpFavoriteHourPresent())
      addHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-hour-message', 'd-none');
    if (this.validHomePickUpFavoriteDay())
      addHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-day-message-2', 'd-none');
    if (this.shipmentAddressPresent())
      addHtmlElementClass(this.shadowRoot, 'invalid-shipment-address-message', 'd-none');
    if (this.userOwnerPresent())
      addHtmlElementClass(this.shadowRoot, 'invalid-user-owner-message', 'd-none');
    if (!this.notGradableProductsPresent())
      addHtmlElementClass(this.shadowRoot, 'invalid-products-message', 'd-none');
    if (this.acceptedInsuranceTou())
      addHtmlElementClass(this.shadowRoot, 'invalid-insurance-tou-message', 'd-none');
    if (this.acceptedInsuranceGuidelines())
      addHtmlElementClass(this.shadowRoot, 'invalid-insurance-guidelines-message', 'd-none');
    if (!this.differentCountriesOnAddresses())
      addHtmlElementClass(this.shadowRoot, 'invalid-countries-on-addresses', 'd-none');
    if (!this.invalidCountryOnHomePickUp())
      addHtmlElementClass(this.shadowRoot, 'invalid-country-on-home-pick-up', 'd-none');
    if (!this.invalidCountryOnReturnShipment())
      addHtmlElementClass(this.shadowRoot, 'invalid-country-on-shipment', 'd-none');
    if (!this.invalidProvinceOnHomePickUp())
      addHtmlElementClass(this.shadowRoot, 'invalid-province-on-home-pick-up', 'd-none');
    if (!this.invalidProvinceOnReturnShipment())
      addHtmlElementClass(this.shadowRoot, 'invalid-province-on-shipment', 'd-none');
    if (!this.maxItemsThresholdExceeded())
      addHtmlElementClass(this.shadowRoot, 'invalid-items-number', 'd-none');
  }


  // Funzione che setta il nuovo codice di sconto immesso dall'utente sull'interfaccia grafica
  setDiscountCode(value) {
    this.discountCode = sanitize(value);
  }


  // Funzione che setta / resetta l'accettazione dei termini di utilizzo del servizio di gradazione da parte dell'utente
  setTouCheckbox() {
    const checkbox = getHtmlElement(this.shadowRoot, 'touCheckbox');
    this.acceptedTou = checkbox.checked;

    if (this.acceptedTou) {
      if (this.enableSubmissionListConfirmation()) {
        this.handleRenderingSubmissionListValidatorSubbanner('validations_container', false, () => {
          addHtmlElementClass(this.shadowRoot, 'invalid-tou-message', 'd-none');
        });
      } else
        addHtmlElementClass(this.shadowRoot, 'invalid-tou-message', 'd-none');
    }
    else
      this.eventBus.publish("updated-submission-list-state", this.props.submissionList);
  }


  // Funzione che si occupa di applicare l'eventuale codice di sconto in possesso dell'utente
  // per il pagamento della submission list
  handleApplyVoucher() {
    if (isDefined(customToString(this.discountCode)) || isDefined(customToString(this.props.submissionList.voucher?.code))) {
      enableHtmlElement(this.shadowRoot, 'apply_voucher_btn', false);
      const url = `/submission_lists/apply_voucher/${this.props.submissionList.id}`;

      fetch(url + ".json", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ voucher_code: this.discountCode })
      })
        .then((response) => {
          if (!response.ok)
            throw Error("An error occour during saving data on the database");
          else
            return response.json();
        })
        .then((submissionList ) => {
          this.eventBus.publish("updated-submission-list-state", submissionList);

          if (submissionList.voucher?.valid_voucher) {
            this.handleRenderingCouponValidatorSubbanner('coupon_outcome_container', true, () => {
              scrollHtmlElementIntoView(this.shadowRoot, 'coupon_outcome_container', false);
            });
            if (submissionList.voucher.percentage > 0)
              setHtmlElementContent(this.shadowRoot, 'validCouponMsg', `${I18n.t('js.editSubmissionListPage.couponValid1')} ${submissionList.voucher.percentage}% ${I18n.t('js.editSubmissionListPage.couponValid2')}`);
            else if (submissionList.voucher.amount > 0)
              setHtmlElementContent(this.shadowRoot, 'validCouponMsg', `${I18n.t('js.editSubmissionListPage.couponValid3')} ${submissionList.voucher.amount}${CURRENCY_EURO} ${I18n.t('js.editSubmissionListPage.couponValid4')}`);
            else
              setHtmlElementContent(this.shadowRoot, 'validCouponMsg', I18n.t('js.editSubmissionListPage.couponValidNoDiscount'));
            removeHtmlElementClass(this.shadowRoot, 'validCouponMsg', 'd-none');
            addHtmlElementClass(this.shadowRoot, 'invalidCouponMsg', 'd-none');
          }
          if (submissionList.voucher?.resetted_voucher) {
            this.hideUserCouponsMsg(this.shadowRoot);
          }
          else if (submissionList.voucher?.invalid_voucher) {
            this.handleRenderingCouponValidatorSubbanner('coupon_outcome_container', true, () => {
              scrollHtmlElementIntoView(this.shadowRoot, 'coupon_outcome_container', false);
            });
            addHtmlElementClass(this.shadowRoot, 'validCouponMsg', 'd-none');
            removeHtmlElementClass(this.shadowRoot, 'invalidCouponMsg', 'd-none');
            setHtmlElementContent(this.shadowRoot, 'invalidCouponMsg', submissionList.voucher.invalid_voucher_message);
          }

          veryVeryHighDebouncedFunction(this.hideUserCouponsMsg, [this.shadowRoot, this]);
        })
        .catch((error) => {
          console.error("ERROR:", error);
          this.eventBus.publish("render-modal", { error: true });
        });
    }
  }


  // Funzione che nasconde dall'interfaccia grafica i messaggi che informano l'utente che il codice sconto da lui
  // immesso sia valido oppure no
  hideUserCouponsMsg(root, scope) {
    if (root && scope) {
      scope.handleRenderingCouponValidatorSubbanner('coupon_outcome_container', false, () => {
        addHtmlElementClass(root, 'coupon-form-container', 'shadow');
        removeHtmlElementClass(root, 'coupon_outcome_container', 'service-subbanner');
        enableHtmlElement(root, 'apply_voucher_btn', true);
      });
    }
  }


  // Funzioni che verificano se la submission list possa essere confermata definitivamente dall'utente oppure no
  graderCompanyPresent() {
    return isDefined(this.props.submissionList.grader_company_id);
  }
  itemsPresent() {
    return this.props.submissionList.items_count > 0;
  }
  userOwnerPresent() {
    return this.props.submissionList.user_id || this.props.submissionList.owner_email;
  }
  unavailableProService() {
    return ['pro', 'fast'].includes(this.props.submissionList.service_type) && this.props.submissionList.unavailable_expedit_home_pick_up;
  }
  homePickupAddressPresent() {
    return (this.props.submissionList[`${this.props.submissionList.created_by}_home_pick_up_address_id`] || !this.props.submissionList.home_pick_up_requested);
  }
  homePickUpFavoriteDayPresent() {
    return (isDefined(this.props.submissionList.home_pick_up_favorite_day) || !this.props.submissionList.home_pick_up_requested || (this.props.submissionList.is_middleman_for_company && this.props.submissionList.has_shipping_collection));
  }
  homePickUpFavoriteHourPresent() {
    return (isDefined(this.props.submissionList.home_pick_up_favorite_hour) || !this.props.submissionList.home_pick_up_requested || (this.props.submissionList.is_middleman_for_company && this.props.submissionList.has_shipping_collection));
  }
  validHomePickUpFavoriteDay() {
    return this.props.submissionList.valid_home_pick_up_favorite_day;
  }
  shipmentAddressPresent() {
    return (this.props.submissionList[`${this.props.submissionList.created_by}_shipment_address_id`] || !this.props.submissionList.return_delivery_requested);
  }
  notGradableProductsPresent() {
    return this.props.submissionList.has_not_gradable_products;
  }

  differentCountriesOnAddresses() {
    return (
      this.props.submissionList.home_pick_up_requested &&
      isPresent(this.props.submissionList['home_pick_up_address']) &&
      this.props.submissionList.return_delivery_requested &&
      isPresent(this.props.submissionList['shipment_address']) &&
      this.props.submissionList['home_pick_up_address']['country_id'] !==
      this.props.submissionList['shipment_address']['country_id']
    );
  }

  invalidCountryOnHomePickUp() {
    const homePickUpAddress = this.props.submissionList['home_pick_up_address'];
    return (
      isPresent(homePickUpAddress) &&
      !this.props.submissionList.grader_company.countries_ids_for_shipments['home_pick_up'].includes(homePickUpAddress['country_id'])
    );
  }

  invalidCountryOnReturnShipment() {
    const shipmentAddress = this.props.submissionList['shipment_address'];
    return (
      isPresent(shipmentAddress) &&
      !this.props.submissionList.grader_company.countries_ids_for_shipments['shipment'].includes(shipmentAddress['country_id'])
    );
  }

  invalidProvinceOnHomePickUp() {
    const homePickUpAddress = this.props.submissionList['home_pick_up_address'];
    return (
      isPresent(homePickUpAddress) &&
      !this.props.submissionList.grader_company.provinces_for_shipments['home_pick_up'].includes(homePickUpAddress['province'])
    );
  }

  invalidProvinceOnReturnShipment() {
    const shipmentAddress = this.props.submissionList['shipment_address'];
    return (
      isPresent(shipmentAddress) &&
      !this.props.submissionList.grader_company.provinces_for_shipments['shipment'].includes(shipmentAddress['province'])
    );
  }

  maxItemsThresholdExceeded() {
    return this.props.submissionList.grader_company?.exceeded_max_items_number;
  }

  acceptedInsuranceTou() {
    const touSessionStorageKey = `${INSURANCE_TOU_ACCEPTED_KEY_FOR_SESSION_STORAGE}${this.props.submissionList.id}`;
    return window.sessionStorage.getItem(touSessionStorageKey)?.toString() === 'true' || !insuranceRequested(this.props.submissionList);
  }

  acceptedInsuranceGuidelines() {
    const insuranceGuidelinesSessionStorageKey = `${INSURANCE_GUIDELINES_ACCEPTED_KEY_FOR_SESSION_STORAGE}${this.props.submissionList.id}`;
    return window.sessionStorage.getItem(insuranceGuidelinesSessionStorageKey)?.toString() === 'true' || !insuranceRequested(this.props.submissionList);
  }

  enableSubmissionListConfirmation() {
    return this.graderCompanyPresent() &&
      this.itemsPresent() &&
      !this.unavailableProService() &&
      this.homePickupAddressPresent() &&
      this.homePickUpFavoriteDayPresent() &&
      this.homePickUpFavoriteHourPresent() &&
      this.validHomePickUpFavoriteDay() &&
      this.shipmentAddressPresent() &&
      this.userOwnerPresent() &&
      !this.notGradableProductsPresent() &&
      this.acceptedTou &&
      this.acceptedInsuranceTou() &&
      this.acceptedInsuranceGuidelines() &&
      !this.differentCountriesOnAddresses() &&
      !this.invalidCountryOnHomePickUp() &&
      !this.invalidCountryOnReturnShipment() &&
      !this.invalidProvinceOnHomePickUp() &&
      !this.invalidProvinceOnReturnShipment() &&
      !this.maxItemsThresholdExceeded();
  }
  
  
  // Funzione che permette all'utente di procedere al checkout della submission list
  proceedToCheckout() {
    if (this.enableSubmissionListConfirmation()) {
      this.handleRenderingSubmissionListValidatorSubbanner('validations_container', false);

      // Genero il numero di submission list e poi permetto all'utente di pagare e confermare la submission list
      const url = `/submission_lists/generate_number/${this.props.submissionList.id}`;

      fetch(url + ".json", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ })
      })
        .then((response) => {
          if (!response.ok)
            throw Error("An error occour during saving data on the database");
          else
            return response.json();
        })
        .then((submissionList) => {
          this.eventBus.publish("updated-submission-list-state", submissionList);
          // Controllo nuovamente che la submission list superi tutte le validazioni perchè potrebbe essersi invalidata
          // da quando l'utente aveva completato l'ultimo aggiornamento a quando ha deciso effettivamente di procedere
          // col checkout
          if (this.enableSubmissionListConfirmation())
            this.renderPaymentForm(submissionList);
          else
            this.renderValidationMessages();
        })
        .catch((error) => {
          console.error("ERROR:", error);
          this.eventBus.publish("render-modal", { error: true });
        });
    } else {
      this.renderValidationMessages();
    }
  }


  // Funzione che renderizza sull'interfaccia grafica i messaggi di errore di validazione
  renderValidationMessages () {
    addHtmlElementClass(this.shadowRoot, 'validations_container', 'border-bottom-solid');
    addHtmlElementClass(this.shadowRoot, 'validations_container', 'pt-4');

    if (!this.acceptedTou)
      removeHtmlElementClass(this.shadowRoot, 'invalid-tou-message', 'd-none');
    else
      addHtmlElementClass(this.shadowRoot, 'invalid-tou-message', 'd-none');

    if (!this.acceptedInsuranceTou())
      removeHtmlElementClass(this.shadowRoot, 'invalid-insurance-tou-message', 'd-none');
    else
      addHtmlElementClass(this.shadowRoot, 'invalid-insurance-tou-message', 'd-none');

    if (!this.acceptedInsuranceGuidelines())
      removeHtmlElementClass(this.shadowRoot, 'invalid-insurance-guidelines-message', 'd-none');
    else
      addHtmlElementClass(this.shadowRoot, 'invalid-insurance-guidelines-message', 'd-none');

    if (!this.itemsPresent())
      removeHtmlElementClass(this.shadowRoot, 'invalid-items-message', 'd-none');
    else
      addHtmlElementClass(this.shadowRoot, 'invalid-items-message', 'd-none');

    if (this.unavailableProService()) {
      removeHtmlElementClass(this.shadowRoot, 'unavailable-pro-service-message', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-address-message', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-day-message', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-hour-message', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-day-message-2', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'invalid-country-on-home-pick-up', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'invalid-province-on-home-pick-up', 'd-none');
    }
    else {
      addHtmlElementClass(this.shadowRoot, 'unavailable-pro-service-message', 'd-none');

      if (!this.homePickupAddressPresent())
        removeHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-address-message', 'd-none');
      else
        addHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-address-message', 'd-none');

      if (!this.homePickUpFavoriteDayPresent())
        removeHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-day-message', 'd-none');
      else
        addHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-day-message', 'd-none');

      if (!this.homePickUpFavoriteHourPresent())
        removeHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-hour-message', 'd-none');
      else
        addHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-hour-message', 'd-none');

      if (!this.validHomePickUpFavoriteDay())
        removeHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-day-message-2', 'd-none');
      else
        addHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-day-message-2', 'd-none');

      if (this.invalidCountryOnHomePickUp())
        removeHtmlElementClass(this.shadowRoot, 'invalid-country-on-home-pick-up', 'd-none');
      else {
        addHtmlElementClass(this.shadowRoot, 'invalid-country-on-home-pick-up', 'd-none');

        if (this.invalidProvinceOnHomePickUp())
          removeHtmlElementClass(this.shadowRoot, 'invalid-province-on-home-pick-up', 'd-none');
        else
          addHtmlElementClass(this.shadowRoot, 'invalid-province-on-home-pick-up', 'd-none');
      }

      if (!this.shipmentAddressPresent())
        removeHtmlElementClass(this.shadowRoot, 'invalid-shipment-address-message', 'd-none');
      else
        addHtmlElementClass(this.shadowRoot, 'invalid-shipment-address-message', 'd-none');

      if (!this.userOwnerPresent())
        removeHtmlElementClass(this.shadowRoot, 'invalid-user-owner-message', 'd-none');
      else
        addHtmlElementClass(this.shadowRoot, 'invalid-user-owner-message', 'd-none');

      if (this.notGradableProductsPresent())
        removeHtmlElementClass(this.shadowRoot, 'invalid-products-message', 'd-none');
      else
        addHtmlElementClass(this.shadowRoot, 'invalid-products-message', 'd-none');

      if (this.differentCountriesOnAddresses())
        removeHtmlElementClass(this.shadowRoot, 'invalid-countries-on-addresses', 'd-none');
      else
        addHtmlElementClass(this.shadowRoot, 'invalid-countries-on-addresses', 'd-none');
    }

    if (this.invalidCountryOnReturnShipment())
      removeHtmlElementClass(this.shadowRoot, 'invalid-country-on-shipment', 'd-none');
    else {
      addHtmlElementClass(this.shadowRoot, 'invalid-country-on-shipment', 'd-none');

      if (this.invalidProvinceOnReturnShipment())
        removeHtmlElementClass(this.shadowRoot, 'invalid-province-on-shipment', 'd-none');
      else
        addHtmlElementClass(this.shadowRoot, 'invalid-province-on-shipment', 'd-none');
    }

    if (this.maxItemsThresholdExceeded())
      removeHtmlElementClass(this.shadowRoot, 'invalid-items-number', 'd-none');
    else
      addHtmlElementClass(this.shadowRoot, 'invalid-items-number', 'd-none');

    scrollHtmlElementIntoView(this.shadowRoot, 'validations_container', false);

    this.handleRenderingSubmissionListValidatorSubbanner('validations_container', true, () => {
      scrollHtmlElementIntoView(this.shadowRoot, 'validations_container', false)
    });
  }


  // Funzione che apre il form di pagamento e conferma della submission list
  renderPaymentForm(submissionList) {
    if (!submissionList.deferred_payments_enabled) {
      appendHtmlElementChild(
          this.shadowRoot,
          new SubmissionListPaymentComponent(
              {
                submissionList: submissionList,
                locale: this.props.locale === 'it' ? 'it_IT' : 'en_US',
                currentUserGenerality: this.props.currentUserGenerality
              }
          )
      );
      enableHtmlElement(this.shadowRoot, 'confirm_and_pay_btn', false);
    } else {
      SubmissionListDeferredPaymentModalComponent.getInstance(this.shadowRoot, this.props.submissionList, 'deferred_payment', this.props.currentUserGenerality)
      enableHtmlElement(this.shadowRoot, 'confirm_and_pay_btn', false);
    }
  }


  // Funzione che renderizza a video, mediante un'animazione di tipo ease-in,
  // il subbanner contenente il messaggio di validazione del codice sconto immesso dall'utente sull'interfaccia grafica
  handleRenderingCouponValidatorSubbanner(id, show, fun) {
    if (show) {
      addHtmlElementClass(this.shadowRoot, id, 'slide-down');
      removeHtmlElementClass(this.shadowRoot, id, 'slide-up');
      addHtmlElementClass(this.shadowRoot, id, 'service-subbanner');
      removeHtmlElementClass(this.shadowRoot, 'coupon-form-container', 'shadow');
    } else {
      addHtmlElementClass(this.shadowRoot, id, 'slide-up');
      removeHtmlElementClass(this.shadowRoot, id, 'slide-down');
    }
    if (fun)
      setTimeout(() => fun(), EASE_IN_TRANSITION_TIME);
  }


  // Funzione che renderizza a video, mediante un'animazione di tipo ease-in,
  // il subbanner contenente i messaggi di validazione dell'intera submission list prima che l'utente proceda al checkout
  handleRenderingSubmissionListValidatorSubbanner(id, show, fun) {
    if (show) {
      addHtmlElementClass(this.shadowRoot, id, 'slide-down');
      removeHtmlElementClass(this.shadowRoot, id, 'slide-up');
      addHtmlElementClass(this.shadowRoot, id, 'border-bottom-solid');
      addHtmlElementClass(this.shadowRoot, id, 'pt-4');
    } else {
      addHtmlElementClass(this.shadowRoot, id, 'slide-up');
      removeHtmlElementClass(this.shadowRoot, id, 'slide-down');
      removeHtmlElementClass(this.shadowRoot, id, 'border-bottom-solid');

      setTimeout(() => {
        removeHtmlElementClass(this.shadowRoot, id, 'pt-4');
      }, EASE_IN_TRANSITION_TIME);
    }

    if (fun)
      setTimeout(() => fun(), EASE_IN_TRANSITION_TIME);
  }



  render() {
    const html = `
      <!-- SEZIONE COUPON DI SCONTO -->
      <div class="w-100 m-0 submission-list-form-initial-sections">
        <div class="mt-5" id="coupon-row">        
          <div class="px-0"> 
            <div class="row border-solid br-20px shadow mx-0" id="coupon-form-container">
              <div class="col-12 col-md-2 d-flex justify-content-center align-items-center bg-aig-gradient border-left-radius-20px shipment-icon-container py-2 z-index-10">
                <img src="/images/icons/white/percentage.svg" 
                  alt="" width="65" height="65" 
                >
              </div>
              
              <div class="col-12 col-md-10 pb-3">
                <div class="row">
                  <div class="col-12 col-lg-7 pb-2">
                    <p><h6 class="mb-4"><b>${I18n.t('js.editSubmissionListPage.enterCoupon')}</b></h6></p>
                    <input
                      type="text"
                      id="discountCode"
                      class="form-control h-40px bg-light-gray mt-2"
                      value="${this.props.submissionList.voucher?.code ? this.props.submissionList.voucher.code : ''}"
                      placeholder="${I18n.t('js.editSubmissionListPage.couponPlacehoder')}"
                    />
                  </div>
                  
                  <div class="col-12 col-lg-5 text-right align-self-end pb-2">
                    <button
                      id="apply_voucher_btn"
                      class="btn-standard bg-aig-gradient color-white br-50px border-none-imp text-center px-5"
                      type="button"
                    >
                      ${I18n.t('js.editSubmissionListPage.apply').toUpperCase()}
                    </button>
                  </div>
                </div>
              </div>
            </div>    
          </div>
        </div>      
        
        <div class="row slide-animation-container mx-0" id="coupon_outcome_container">
          <div class="col-12 col-md-2"></div>
          
          <div class="col-12 col-md-10 pt-4 border-bottom-radius-20px border-bottom-solid border-right-solid border-left-solid shadow-on-left-bottom-right">
            <p class="text-left text-aiBlue d-none px-0 mt-2 font-size-1rem" id="validCouponMsg">
              ${I18n.t('js.editSubmissionListPage.couponValidCompact')}
            </p>
            <p class="text-left text-aiBlue d-none px-0 mt-2 font-size-1rem" id="invalidCouponMsg">
              ${I18n.t('js.editSubmissionListPage.couponInvalid')}
            </p>
          </div>
        </div>
      </div>
        
        
        
        
        
      <div class="w-100 m-0 submission-list-form-last-sections">
        <!-- SEZIONE RACCOMANDAZIONI PER IL CLIENTE FINALE -->
        <div id="remarks_container"></div>
          
          
          
          
          
        <!-- TITOLO -->
        <div class="mt-5 align-items-center">
          <div class="row d-flex justify-content-center text-center text-aig-gradient">
            <h2><b>${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.summary')}</b></h2>
          </div>
        </div>
          
          
          
          
          
        <!-- SEZIONE RIEPILOGO PER IL CLIENTE FINALE 
             (renderizzato solo per l'aggregatore) -->
        <div class="w-100 mx-0 mt-4 mb-1 p-0" id="customer_summary">
          <div class="d-flex justify-content-center text-center text-aig-gradient">  
            <h4><b>${I18n.t('js.editSubmissionListPage.webComponent.draft.customerPrices')}</b></h4>
          </div>
          
          <div class="row br-20px bg-aig-gradient-light pt-0 z-index-125 m-auto overflow-auto position-relative">  
            <div class="col-6 col-lg-4 text-break py-2 min-h-58px-imp">
              <span>
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.service_amount').toUpperCase()}
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.vatIncluded').toUpperCase()}  
              </span>
              <br>
              <h6 class="mb-0">
                <b><span id="customer_summary_box_content_1"></span>${CURRENCY_EURO}</b>
              </h6>
            </div>
            
            <div class="col-6 col-lg-4 text-break py-2 min-h-58px-imp" id="customer_shipping_cost_container">
              <span>
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.shipping').toUpperCase()} 
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.vatIncluded').toUpperCase()}
              </span>
              <br>
              <h6 class="mb-0">
                <b><span id="customer_summary_box_content_2"></span></b>
              </h6>
            </div>
            
            <div class="col-6 col-lg-4 text-break py-2 min-h-58px-imp" id="customer_insurance_cost_container">
              <span>
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.insurance').toUpperCase()} 
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.vatIncluded').toUpperCase()}
              </span>
              <br>
              <h6 class="mb-0">
                <b><span id="customer_summary_box_content_3"></span></b>
              </h6>
            </div>
            
            <div class="col-6 col-lg-4 text-break py-2 min-h-58px-imp">
              <span>
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.vatRate').toUpperCase()}
              </span>
              <br>
              <h6 class="mb-0">
                <b><span id="customer_summary_box_content_4"></span></b>
              </h6>
            </div>
            
            <div class="col-6 col-lg-4 text-break py-2 min-h-58px-imp">
              <span>
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.vatAmount').toUpperCase()}
              </span>
              <br>
              <h6 class="mb-0">
                <b><span id="customer_summary_box_content_5"></span></b>
              </h6>
            </div>
            
            <div class="col-6 col-lg-4 text-break py-2 min-h-58px-imp">
              <span>
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.paidAmount').toUpperCase()}
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.vatIncluded').toUpperCase()}
              </span>
              <br>
              <h6 class="mb-0">
                <b><span id="customer_summary_box_content_6"></span></b>
              </h6>
            </div>
            
            <div class="d-block d-xl-flex justify-content-between align-items-center mx-0 py-1 px-3 w-100"> 
              <div id="customer_pricing_details_link" 
                class="text-left align-items-center py-1 cursor-pointer text--white-space-no-wrap pr-5">
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.viewPricingDetails').toUpperCase()}
              </div>
              
              <div id="customer_confirmation_section_container" class="d-block d-lg-flex justify-content-between align-items-center p-0 m-0 w-100"></div>
            </div>
          </div>
        </div>
          
          
          
          
          
        <!-- SEZIONE RIEPILOGO DI PAGAMENTO FINALE ALLA CASA DI GRADAZIONE -->
        <div class="w-100 mx-0 mb-1 p-0" id="summary">
          <div class="d-flex justify-content-center text-center text-aig-gradient mt-4" id="middleman_prices_title">  
            <h4><b>${I18n.t('js.editSubmissionListPage.webComponent.draft.middlemanPrices')}</b></h4>
          </div>
          
          <div class="row br-20px bg-aig-gradient text-white pt-0 z-index-125 m-auto overflow-auto position-relative">       
            <div class="col-6 col-lg-4 text-break py-2 min-h-58px-imp summary-gradient-5">
              <span id="summary_box_title_1"></span>
              <br>
              <h6 class="mb-0">
                <b><span id="summary_box_content_1"></span>${CURRENCY_EURO}</b>
              </h6>
            </div>
            
            <div class="col-6 col-lg-4 text-break py-2 pr-0 min-h-58px-imp summary-gradient-2">
              <span id="summary_box_title_2"></span>
              <br>
              <h6 class="mb-0">
                <b><span id="summary_box_content_2"></span></b>
              </h6>
            </div>
            
            <div class="col-6 col-lg-4 text-break py-2 min-h-58px-imp summary-gradient-3" id="shipping_cost_container">
              <span id="summary_box_title_3"></span>
              <br>
              <h6 class="mb-0">
                <b><span id="summary_box_content_3"></span></b>
              </h6>
            </div>
            
            <div class="col-6 col-lg-4 text-break py-2 min-h-58px-imp summary-gradient-4" id="insurance_cost_container">
              <span id="summary_box_title_4"></span>
              <br>
              <h6 class="mb-0">
                <b><span id="summary_box_content_4"></span></b>
              </h6>
            </div>
            
            <div class="col-6 col-lg-4 text-break py-2 min-h-58px-imp summary-gradient-5">
              <span id="summary_box_title_5"></span>
              <br>
              <h6 class="mb-0">
                <b><span id="summary_box_content_5"></span></b>
              </h6>
            </div>
            
            <div class="col-6 col-lg-4 text-break py-2 min-h-58px-imp summary-gradient-6">
              <b id="summary_box_title_6"></b>
              <br>
              <h6 class="mb-0">
                <b>
                  <span id="summary_box_content_6"></span>
                  <small>${I18n.t('js.editSubmissionListPage.webComponent.draft.vatIncludedExtended')} <span id="summary_box_content_6_vat">${this.props.submissionList.vat_rate}</span>%</small>  
                </b>
              </h6>
            </div>
            
            <div class="d-block d-xl-flex justify-content-between align-items-center mx-0 py-1 px-3 w-100"> 
              <div id="pricing_details_link" 
                class="color-white text-left align-items-center py-1 cursor-pointer text--white-space-no-wrap pr-5">
                ${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.viewPricingDetails').toUpperCase()}
              </div>
              
              <div id="confirmation_section_container" class="d-block d-lg-flex justify-content-between align-items-center p-0 m-0 w-100"></div>
            </div>
          </div>
        </div>
          
          
          
          
          
        <!-- SEZIONE MESSAGGI DI ERRORE PER L'UTENTE -->
        <div class="d-flex justify-content-center align-items-center m-0 p-0 w-100">
          <div id="validations_container"
           class="row slide-animation-container mx-0 w-100 w-md-65 mt--15px-imp border-bottom-radius-20px border-left-solid border-right-solid d-block justify-content-center shadow-on-left-bottom-right slide-animation-container text-aiBlue font-size-1rem">
            <div class="col-12 d-none m-2" id="invalid-user-owner-message">
              ${I18n.t('js.editSubmissionListPage.webComponent.validation.text4')}
            </div>
            
            <div class="col-12 d-none m-2" id="invalid-items-message">
              ${I18n.t('js.editSubmissionListPage.webComponent.validation.text1')}
            </div>
            
            <div class="col-12 d-none m-2" id="unavailable-pro-service-message">
              ${I18n.t('js.editSubmissionListPage.webComponent.validation.text18')}
            </div>
            
            <div class="col-12 d-none m-2" id="invalid-home-pick-up-address-message">
              ${I18n.t('js.editSubmissionListPage.webComponent.validation.text2')}
            </div>
            
            <div class="col-12 d-none m-2" id="invalid-home-pick-up-day-message">
              ${I18n.t('js.editSubmissionListPage.webComponent.validation.text7')}
            </div>
            
            <div class="col-12 d-none m-2" id="invalid-home-pick-up-hour-message">
              ${I18n.t('js.editSubmissionListPage.webComponent.validation.text8')}
            </div>
            
            <div class="col-12 d-none m-2" id="invalid-home-pick-up-day-message-2">
              ${
                I18n.t('js.editSubmissionListPage.webComponent.validation.text9')
                  .replaceAll(':start_day', this.props.submissionList.home_pick_up_time_range_italian_format[0])
              }
            </div>
            
            <div class="col-12 d-none m-2" id="invalid-shipment-address-message">
              ${I18n.t('js.editSubmissionListPage.webComponent.validation.text5')}
            </div>
            
            <div class="col-12 d-none m-2" id="invalid-products-message">
              ${I18n.t('js.editSubmissionListPage.webComponent.validation.text6')}
            </div>
            
            <div class="col-12 d-none m-2" id="invalid-tou-message">
              ${I18n.t('js.editSubmissionListPage.webComponent.validation.text3')}
            </div>
            
            <div class="col-12 d-none m-2" id="invalid-insurance-tou-message">
              ${I18n.t('js.editSubmissionListPage.webComponent.validation.text10')}
            </div>
            
            <div class="col-12 d-none m-2" id="invalid-insurance-guidelines-message">
              ${I18n.t('js.editSubmissionListPage.webComponent.validation.text11')}
            </div>
            
            <div class="col-12 d-none m-2" id="invalid-countries-on-addresses">
              ${I18n.t('js.editSubmissionListPage.webComponent.validation.text12')}
            </div>
            
            <div class="col-12 d-none m-2" id="invalid-country-on-home-pick-up">
              ${I18n.t('js.editSubmissionListPage.webComponent.validation.text13')}
            </div>
            
            <div class="col-12 d-none m-2" id="invalid-country-on-shipment">
              ${I18n.t('js.editSubmissionListPage.webComponent.validation.text14')}
            </div>
            
            <div class="col-12 d-none m-2" id="invalid-province-on-home-pick-up">
              ${I18n.t('js.editSubmissionListPage.webComponent.validation.text15')}
            </div>
            
            <div class="col-12 d-none m-2" id="invalid-province-on-shipment">
              ${I18n.t('js.editSubmissionListPage.webComponent.validation.text16')}
            </div>
            
            <div class="col-12 d-none m-2" id="invalid-items-number">
              ${
                I18n.t('js.editSubmissionListPage.webComponent.validation.text17')
                  .replaceAll(':order_type', I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${this.props.submissionList.service_type || (this.props.submissionList.speed === 'expedit' ? 'pro' : 'basic')}.title`))
                  .replaceAll(':items_threshold', this.props.submissionList.grader_company[`${this.props.submissionList.speed === 'expedit' ? 'expedit_' : ''}submission_list_items_max_number`])
              }
            </div>
          </div>
        </div>
      </div>
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles, submissionListsStyles]);
    this.updateSubmissionListState(this.props.submissionList);
    this.handleFormConfirmationSectionRendering();
  }
}

window.customElements.define("submission-list-summary-component", SubmissionListSummaryComponent);